import { Resources, useResource } from "Infrastructure/Translation/Resources";
import type { CustomerEditFormModel } from "Order/Components/Form/Schema/customerEditSchema";
import Input from "Shared/Components/Form/CustomFormComponent/Input";
import { FormHelperText, Grid2 } from "@mui/material";
import { type FC, useEffect, useState } from "react";
import type { UseFormReturn } from "react-hook-form";

type Props = {
	form: UseFormReturn<CustomerEditFormModel>;
};

const orderResources = Resources.base.order;

export const CustomerEditForm: FC<Props> = ({ form }) => {
	const { t } = useResource();

	const [isCustomerBillingVisible, setIsCustomerBillingVisible] =
		useState(false);

	useEffect(() => {
		const showInput = [
			form.getValues("invoicingName"),
			form.getValues("invoicingAddress"),
			form.getValues("businessId"),
		].some((value) => {
			return !!value;
		});
		setIsCustomerBillingVisible(showInput);
	}, []);

	const {
		control,
		formState: { errors },
	} = form;

	return (
		<form>
			<Grid2 container spacing={2}>
				<Grid2 size={{ xs: 12, md: 4 }}>
					<Input
						id="name"
						name="name"
						label={t(orderResources.detail.info.name)}
						variant="outlined"
						control={control}
						errors={errors}
						fullWidth
						sxLabel={{ mt: 0 }}
					/>
				</Grid2>
				<Grid2 size={{ xs: 12, md: 4 }}>
					<Input
						id="phone"
						name="phone"
						label={t(orderResources.detail.info.phone)}
						variant="outlined"
						control={control}
						errors={errors}
						fullWidth
						sxLabel={{ mt: 0 }}
					/>
				</Grid2>
				<Grid2 size={{ xs: 12, md: 4 }}>
					<Input
						id="email"
						name="email"
						label={t(orderResources.detail.info.email)}
						variant="outlined"
						control={control}
						errors={errors}
						fullWidth
						sxLabel={{ mt: 0 }}
					/>
				</Grid2>
			</Grid2>
			<FormHelperText
				sx={{
					cursor: "pointer",
					color: (theme) => theme.palette.primary.main,
				}}
				onClick={() => setIsCustomerBillingVisible(!isCustomerBillingVisible)}
			>
				{isCustomerBillingVisible
					? t(orderResources.editForm.hide)
					: t(orderResources.editForm.show)}
			</FormHelperText>
			{isCustomerBillingVisible && (
				<Grid2 container spacing={2}>
					<Grid2 size={{ xs: 12, md: 4 }}>
						<Input
							id="invoicingName"
							name="invoicingName"
							label={t(orderResources.detail.info.invoicingName)}
							variant="outlined"
							control={control}
							errors={errors}
							fullWidth
						/>
					</Grid2>
					<Grid2 size={{ xs: 12, md: 4 }}>
						<Input
							id="invoicingAddress"
							name="invoicingAddress"
							label={t(orderResources.detail.info.invoicingAddress)}
							variant="outlined"
							control={control}
							errors={errors}
							fullWidth
						/>
					</Grid2>
					<Grid2 size={{ xs: 12, md: 4 }}>
						<Input
							id="businessId"
							name="businessId"
							label={t(orderResources.detail.info.businessId)}
							variant="outlined"
							control={control}
							errors={errors}
							fullWidth
						/>
					</Grid2>
				</Grid2>
			)}
		</form>
	);
};
